<template lang="pug">
  v-card(class="ma-0")
    div(class="px-2")
      v-text-field(
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      )
    v-data-table(
      :headers="headers"
      :items="splrPdList"
      :footer-props="{ 'items-per-page-options': [5, 10 ,15, 20] }"
      :loading="splrPdLoading"
      loading-text="Loading... Please wait"
      class="elevation-0"
      :search="search"
    )
      template(v-slot:item="row")
        tr
          td {{ row.item.stock_code }}
          td {{ row.item.product_name }}
          td {{ row.item.brand_name }}
          td ₱ {{ formatMoney(row.item.cost) }} / 
            span(class="text-uppercase") {{ row.item.unit }}
          td ₱ {{ formatMoney(row.item.retail) }} / 
            span(class="text-uppercase") {{ row.item.unit }}
          td 
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  class="mx-2"
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="green"
                  :loading="deleting"
                  @click="clkChangeSupplier(row.item)"
                )
                  v-icon(dark) mdi-account-arrow-right
              span Change Supplier
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  class="mx-2"
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="yellow"
                  :loading="deleting"
                  @click="edit(row.item)"
                )
                  v-icon(dark) mdi-pencil
              span Edit
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  class="mx-2"
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="red"
                  :loading="deleting"
                  @click="initDelete(row.item.id)"
                )
                  v-icon(dark) mdi-delete
              span Remove
    change-supplier(ref="changeSupplier")
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { moneyMixin } from './../../mixins/helper.mixins'
import splrPdRepository from '@/repositories/supplier-product.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { errorHandler } from '../../../../extra-functions/store.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'

const getDelay = searchDelay()

function tableVars() {
  return {
    headers: [
      { text: 'Stock Code', align: 'start', value: 'stock_code' },
      { text: 'Product', value: 'product_name' },
      { text: 'Brand', value: 'brand_name' },
      { text: 'Cost', value: 'cost' },
      { text: 'Retail', value: 'retail' },
      { text: 'Config', sortable: false },
    ],
    itemsPerPage: 5,
    page: 1,
    search: '',
  }
}

export default {
  name: 'VIndexStock',
  components: {
    changeSupplier: () => import('./ChangeSupplier'),
  },
  props: {
    propSupplierId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ...apiVars('splrPd'),
      ...tableVars(),
    }
  },
  created() {
    this.getSplrPd()
  },
  computed: {
    ...mapState({
      unitUpdated: state => state.unit.channelUpdate,
      stockUpdated: state => state.unit.channelUpdate,
      supplierProductUpdated: state => state.supplierProduct.channelUpdate,
      deleting: state => state.supplierProduct.deleting,
      storeId: state => state.settings.storeId,
    }),
  },
  watch: {
    propSupplierId(val) {
      this.getSplrPd()
    },
    supplierProductUpdated() {
      this.getSplrPd()
    },
    unitUpdated() {
      this.getSplrPd()
    },
    stockUpdated() {
      this.getSplrPd()
    },
    splrPdList(data) {
      this.$emit('list-update', data)
    },
  },
  methods: {
    ...mapActions({
      fetch: 'supplierProduct/fetch',
      delete: 'supplierProduct/delete',
    }),
    initDelete(id) {
      this.delete({ id })
    },
    edit(data) {
      this.$emit('edit-supplier-product', data)
    },
    getSplrPd() {
      this.splrPdLoading = true
      getDelay(() => {
        splrPdRepository.storeList(this.propSupplierId, this.storeId)
          .then(({ data }) => { this.splrPdList = data })
          .catch(e => { this.splrPdErrors = errorHandler(e) })
          .then(() => { this.splrPdLoading = false })
      })
    },
    clkChangeSupplier(supplierProduct) {
      const { changeSupplier } = this.$refs
      changeSupplier.setSupplierProduct(supplierProduct)
      changeSupplier.open()
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
